import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { PostHogProvider } from 'posthog-js/react';

// PostHog configuration
const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST;
const isProduction = import.meta.env.PROD;
const isPostHogDebug = import.meta.env.VITE_POSTHOG_DEBUG === 'true';

// Validate PostHog configuration
if (!posthogHost && posthogKey) {
  console.error('VITE_POSTHOG_HOST is required when VITE_POSTHOG_KEY is provided');
}

const posthogOptions = {
  api_host: posthogHost,
  person_profiles: 'identified_only' as const,
  // Disable if missing key OR host
  disabled: !posthogKey || !posthogHost,
  // Add proper development configuration
  debug: isPostHogDebug && import.meta.env.DEV,
  // Keep session recording enabled
  disable_session_recording: false,
  // Eliminate retries to prevent cascading failures
  request_batching: false,
  // No retries on failed requests
  retry_queue_size: 0,
  loaded: (posthog: any) => {
    if (import.meta.env.DEV && posthogKey && posthogHost) {
      console.log('PostHog loaded successfully with host:', posthogHost);
      console.log('PostHog session recording enabled, retry logic disabled');
    }
  }
};

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

// Error logging system has been removed

createRoot(rootElement).render(
  <React.StrictMode>
    <PostHogProvider 
      apiKey={posthogKey || ''}
      options={posthogOptions}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>
);


